<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>

export default {
    name: "app",
    data() {
        return {
            paymentMethodsFetched: false,
        };
    },
    watch: {
        $route(to) {
            const query = Object.assign({}, to.query);
            this.$store.commit("SETUP_URL_SETTINGS", query);
            this.fetchPaymentMethodsForRoute(to);
        },
    },
	methods: {
		routeRequiresAuth(route = this.$route) {
			return route.matched.some((record) => record.meta.authRequired);
		},
		fetchPaymentMethodsForRoute(route = this.$route) {
			if (this.paymentMethodsFetched || !this.routeRequiresAuth(route)) {
				return;
			}

			this.paymentMethodsFetched = true;
			this.fetchPaymentMethods();
		},
		async fetchPaymentMethods() {
			try {
				let { data } = await this.$api.get(`/super-admin/payment-methods?_limit=-1`);
				this.$store.commit("SET_PAYMENT_METHODS", data)
			} catch (err) {
				// Handle the error
			}
		}
	},
	created() {
		this.fetchPaymentMethodsForRoute();
	}
};
</script>
<style lang="scss">
#app {
    min-height: 100vh;
}

.ant-layout.ant-layout-has-sider > .ant-layout,
.ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: hidden !important;
}
</style>

<style lang="scss">
.hide-scrollbar::-webkit-scrollbar {
    display: none;
}
</style>
